'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const jsxRuntime = require('react/jsx-runtime');
const components_display_Spinner_Spinner = require('../../display/Spinner/Spinner.cjs.js');
const components_navigation_LegacyButton_Button = require('../LegacyButton/Button.cjs.js');

const spinner = "_spinner_3kaqk_1";
const styles = {
	spinner: spinner
};

const LoadMoreBar = (props) => {
  const { children, isLoading, onClick, size } = props;
  const spinner = jsxRuntime.jsxs("span", { className: styles.spinner, "data-zds": true, children: [jsxRuntime.jsx(components_display_Spinner_Spinner.Spinner, { color: "dark", "aria-label": "Loading icon" }), "Loading"] });
  return jsxRuntime.jsx(components_navigation_LegacyButton_Button.LegacyButton, { color: "secondary", disabled: isLoading, isFullWidth: true, onClick, size, children: isLoading ? spinner : children });
};

exports.LoadMoreBar = LoadMoreBar;
//# sourceMappingURL=LoadMoreBar.cjs.js.map
